import React, { Component } from 'react';
import { getJsonItem } from '../Utilities/JsonFunctions.js'
import FormAutocomplete from './FormAutocomplete.js';
import { getTranslation } from '../Utilities/GetTranslation.js';

class NamezzzCountry extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editCountry: false,
        }
        
        this.editCountry = this.editCountry.bind(this);
        this.setCountry = this.setCountry.bind(this);
        this.blurCountry = this.blurCountry.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.onEscape = this.onEscape.bind(this);
    }

    onEscape(e) {
        this.setState({
            editCountry:false
        });
    }

    componentDidUpdate() {
        if (this.refs.elCountry == null) {
            return;
        }
        this.refs.elCountry.el.focus();
    }

    editCountry() {
        this.setState({
            editCountry: true,
            editCountryId: null
        });
    }

    setCountry() {
        this.setState({
            editCountry:false
        });

        if (this.state.editCountryId == null) {
            return;
        }

        this.props.onCountryChange(this.state.editCountryId);
    }

    blurCountry() {
        // Fix for touch triggering twice in React ( https://github.com/facebook/react/issues/2061 )
        setTimeout(() => {
            this.setCountry();    
        }, 1);        
    }

    onCountryChange(e, id) {
        this.setState({
            editCountryId: id
        });
    }

    getCountryText() {
        var item = getJsonItem(this.props.countries, "key", this.props.countryId);
        
        if (item == null) {
            return null;
        }

        return item.value;
    }

    render() {
        

        return (
            <h4 className="legend-title country">
                <span>
                    {
                        (this.props.text) ? <span className="subtitle">{this.props.text}</span> : ""
                    }
                    <span className="title">{getTranslation("sns.webparts.countries.country")}:</span>&nbsp;
                </span>
                {
                    (this.state.editCountry || false) ?
                        <div>
                            <FormAutocomplete id="inputCountry" ref="elCountry"
                                seqlang={this.props.languageId} data={this.props.countries}
                                value={this.state.editCountryId} onChange={this.onCountryChange}
                                onEnter={this.setCountry} onEscape={this.onEscape} onBlur={this.blurCountry} />
                            <input type="button" className="FormButton btn btn-primary act" value={getTranslation("sns.webparts.countries.change")} onClick={this.setCountry} />
                        </div> :
                        <div>
                            <div className="EditingFormValueCell td">
                                {this.getCountryText()}
                            </div>
                            <input type="button" className="FormButton btn btn-primary act" value={getTranslation("sns.webparts.countries.change")} onClick={this.editCountry} />
                        </div>
                }
            </h4>
        );
    }
}

export default NamezzzCountry;



// WEBPACK FOOTER //
// ./src/Fields/NamezzzCountry.js